import type { UseQueryResult } from "@edreamsodigeo/frontend-api-client";
import { useQuery } from "@edreamsodigeo/frontend-api-client";

import { isMembershipActivated } from "~/clientState/hooks/utils/MembershipUtils";
import type {
  GetMembershipQuery,
  GetMembershipQueryVariables,
  MembershipRequest,
} from "~/generated/graphql";
import { GET_MEMBERSHIP } from "../providers/operations/membership";
import { useShoppingInfo } from "./useShoppingInfo";

/**@deprecated : Use userAccount query */
const useMembershipQuery = (): UseQueryResult<
  GetMembershipQuery,
  GetMembershipQueryVariables
> => {
  const shoppingInfo = useShoppingInfo();
  const membershipRequest: MembershipRequest = {
    shoppingInfo,
  };
  return useQuery<GetMembershipQuery, GetMembershipQueryVariables>(
    GET_MEMBERSHIP,
    {
      variables: {
        membershipRequest,
      },
    },
  );
};

export const useIsActivePrimeMember = (): boolean => {
  const { data, loading } = useMembershipQuery();
  return !data && loading ? false : isMembershipActivated(data);
};

export default useMembershipQuery;
